import { AnalyticsData } from '@all-hands-hq/plex-graphql-schema';
import amplitude from 'amplitude-js';

import { useEffectOnce } from '../details/useEffectOnce';

export function logAnalytics(data: AnalyticsData): void {
  Promise.all([
    amplitude.logEvent(data.name, data.details),
    fetch('/api/analytics/event', {
      method: 'POST',
      body: JSON.stringify(data),
      headers: { 'content-type': 'application/json' },
    }),
  ]);
}

export function useLogAnalytics(data: AnalyticsData): void {
  useEffectOnce(() => logAnalytics(data));
}

export { AnalyticsLocation } from '@all-hands-hq/plex-graphql-schema';
